const Banner = ({ config }) => {
  return (
    <div className="bg-[#F9FCD0] py-14 text-center px-4">
      {/* Job Title and Company Info */}
      <div className="text-gray-700 text-sm font-medium mb-3">
        Lentera Technologies <span className="mx-2">|</span> Full Time
      </div>
      <h1 className="text-3xl md:text-5xl font-semibold text-gray-900 mb-6">
        {config.title}
      </h1>

      {/* I'm Interested Button */}
      <button
        onClick={() =>
          config.applyFormRef.current.scrollIntoView({ behavior: "smooth" })
        }
        className="bg-[#F4B731] hover:bg-[#e5a925] text-black font-semibold px-6 py-3 rounded-md text-sm md:text-base transition-all duration-200"
      >
        I’M INTERESTED <span className="ml-1">→</span>
      </button>
    </div>
  );
};

export default Banner;
